import { Rule } from '../types';
import { computeSlope } from '@gorampe/calc-engine';

export const ruleSlope: Rule = (submission) => {
  if (submission.config.shape.kind !== 'straight') return null;
  const slope = computeSlope(submission.config.heightIn, submission.config.shape.totalRunIn);

  switch (slope.flag) {
    case 'ok':
      return {
        ruleId: 'slope-ok-1-12',
        severity: 'info',
        humanMessage: `Pente 1:12 (${slope.percent.toFixed(1)}%) — conforme`,
      };
    case 'acceptable-1-11':
      return {
        ruleId: 'slope-warn-1-11',
        severity: 'warn',
        humanMessage: `Pente 1:11 (${slope.percent.toFixed(1)}%) — acceptable mais surveiller`,
      };
    case 'acceptable-1-10':
      return {
        ruleId: 'slope-warn-1-10',
        severity: 'warn',
        humanMessage: `Pente 1:10 (${slope.percent.toFixed(1)}%) — acceptable mais surveiller`,
      };
    case 'limit-1-9':
      return {
        ruleId: 'slope-warn-1-9',
        severity: 'warn',
        humanMessage: `Pente 1:9 (${slope.percent.toFixed(1)}%) — proche du maximum`,
      };
    case 'max-absolute':
      return {
        ruleId: 'slope-warn-1-8',
        severity: 'warn',
        humanMessage: `Pente 1:8 (${slope.percent.toFixed(1)}%) — maximum absolu Guide Go Rampe`,
      };
    case 'error': {
      const requiredRunIn = submission.config.heightIn * 8;
      return {
        ruleId: 'slope-error-too-steep',
        severity: 'error',
        humanMessage: `Pente trop forte (${slope.percent.toFixed(1)}%). On rallonge la rampe à ${requiredRunIn}" ?`,
        suggestion: {
          type: 'increase-length',
          patch: {
            config: {
              ...submission.config,
              shape: { kind: 'straight', totalRunIn: requiredRunIn },
            },
          },
        },
      };
    }
  }
};
